/* global sh_hub_config */

import lozad from 'lozad';
import { createApp } from 'vue';

import { rest_request } from './_partials/_rest.js';
import App from './hub-app/app.vue';

(function () {
	const app_el = document.getElementById(`js-hub-hero-featured-app`);
	if (!app_el) {
		return;
	}

	if (typeof sh_hub_config !== `object`) {
		return;
	}

	const app = createApp(App, sh_hub_config);

	app.mount(app_el);
})();

(function () {
	const form_el = document.getElementById(`js-hub-hero-search-form`);
	if (!form_el) {
		return;
	}

	const input_el = form_el.querySelector(`input[type="search"]`);
	if (!input_el) {
		return;
	}

	let controller = null;

	let timer = null;

	let dropdown_el = null;

	function close() {
		if (!dropdown_el) {
			return;
		}

		dropdown_el.parentNode.removeChild(dropdown_el);
		dropdown_el = null;

		document.removeEventListener(`keyup`, close_esc);
		window.removeEventListener(`click`, close_click);
	}

	function close_click(e) {
		if (form_el.contains(e.target)) {
			return;
		}

		close();
	}

	function close_esc(e) {
		if (e.keyCode === 27) {
			close();
		}
	}

	function draw(ideas) {
		close();

		if (ideas.length === 0) {
			return;
		}

		dropdown_el = document.createElement(`ul`);

		for (const idea of ideas) {
			const item_el = document.createElement(`li`);

			const link_el = document.createElement(`a`);
			link_el.href = idea.url;
			item_el.appendChild(link_el);

			const title_el = document.createElement(`p`);
			title_el.textContent = idea.title;
			link_el.appendChild(title_el);

			if (idea.rate) {
				const span_el = document.createElement(`span`);
				span_el.textContent = idea.rate;
				link_el.appendChild(span_el);
			}

			dropdown_el.appendChild(item_el);
		}

		form_el.appendChild(dropdown_el);

		document.addEventListener(`keyup`, close_esc);
		window.addEventListener(`click`, close_click);
	}

	function search() {
		if (controller) {
			controller.abort();
			controller = null;
		}

		if (input_el.value === ``) {
			draw([]);
			return;
		}

		controller = new AbortController();

		rest_request(`ideas/search`, {
			method: `POST`,
			signal: controller.signal,
			data: {
				q: input_el.value,
				page: 1,
			},
		})
			.then(draw)
			.catch(() => {
				// Do nothing
			});
	}

	function on_input() {
		if (timer) {
			clearTimeout(timer);
		}

		timer = setTimeout(search, 50);
	}

	input_el.addEventListener(`input`, on_input);

	search();
})();

(function () {
	const observer = lozad(`.hub-section-carousel .carousel`, {
		load(el) {
			const carousel_cell_els = el.getElementsByClassName(`carousel-cell`);
			if (carousel_cell_els.length <= 1) {
				return;
			}

			import(`flickity`).then(({ default: Flickity }) => {
				new Flickity(el, {
					wrapAround: true,
					// autoPlay: 5000,
					// cellAlign: `left`,
					// adaptiveHeight: true,
					pageDots: true,
					prevNextButtons: true,
				});
			});
		},
	});

	observer.observe();
})();

(function () {
	const container_els = document.querySelectorAll(`.hub-section-experts .rows`);
	if (container_els.length === 0) {
		return;
	}

	function Scrolling_Rows(container_el) {
		const row_els = container_el.querySelectorAll(`.row`);

		let ticking = false;

		function update() {
			for (let i = 0; i < row_els.length; i++) {
				const row_el = row_els[i];

				let percentage = window.scrollY / document.body.scrollHeight;

				if (row_el.classList.contains(`odd`)) {
					percentage *= -1;
				}

				row_el.style.transform = `translateX(${(percentage * 100) / 2}%)`;
			}

			ticking = false;
		}

		function request_tick() {
			if (ticking) {
				return;
			}

			window.requestAnimationFrame(update);
			ticking = true;
		}

		window.addEventListener(`scroll`, request_tick);
	}

	for (let i = 0; i < container_els.length; i++) {
		new Scrolling_Rows(container_els[i]);
	}
})();
